import { Component, computed, input, output, signal } from "@angular/core"
import { SearchableSelectOption } from "../../models"
import { SearchableSelectComponent } from "../searchable-select/searchable-select.component"

type Country = { code: string; name: string }

@Component({
    selector: "valben-countries-dropdown",
    templateUrl: "./countries-dropdown.component.html",
    styleUrls: ["../../helpers/flags.css"],
    standalone: true,
    imports: [SearchableSelectComponent],
})
export class CountriesDropdownComponent {
    options = input.required<Country[]>()
    signal = output<{ code: string }>()
    selectedCountryCode = signal<string | null>(null)
    countryOptions = computed<SearchableSelectOption<string, Country>[]>(() =>
        this.options().map(country => ({
            value: country.code,
            label: country.name,
            searchText: `${country.name} ${country.code}`,
            data: country,
        }))
    )

    selectCountry(code: string | null): void {
        this.selectedCountryCode.set(code)
        if (code) this.signal.emit({ code })
    }
}
